import { render, staticRenderFns } from "./custom-form-type.vue?vue&type=template&id=e5edc2d4&scoped=true&"
import script from "./custom-form-type.vue?vue&type=script&lang=js&"
export * from "./custom-form-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5edc2d4",
  null
  
)

export default component.exports